import { render, staticRenderFns } from "./mealBook.vue?vue&type=template&id=26e5a590&scoped=true"
import script from "./mealBook.vue?vue&type=script&lang=js"
export * from "./mealBook.vue?vue&type=script&lang=js"
import style0 from "./mealBook.vue?vue&type=style&index=0&id=26e5a590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e5a590",
  null
  
)

export default component.exports